import { useContext } from 'react';

import { StoreContext } from '../StoreContext.js';
import { Store } from '../types.js';

export const useStoreApi = (): Store => {
  const store = useContext(StoreContext);

  if (!store) {
    throw new Error('useStoreApi must be used within a StoreProvider');
  }

  return store;
};
